import {VoteAndCompanyResource} from '@services/resource/vote-and-company-resource';

export class MyVotesResource {
  constructor(
    public readonly total: number,
    public readonly votes: VoteAndCompanyResource[],
  ) {}
}
